import { api, extractResponseData } from "./base";

export const readabilityService = {
  translateText: async ({ text }) => {
    const data = { text };
    try {
      const response = await api.post("/platform/text/translate", data);
      return extractResponseData(response);
    } catch (error) {
      console.error("Error in translation:", error);
      throw new Error(`Translation failed: ${error.message}`);
    }
  },

  lookupText: async ({ text }) => {
    const data = { text };
    try {
      const response = await api.post("/platform/text/lookup", data);
      return extractResponseData(response);
    } catch (error) {
      console.error("Error in lookup:", error);
      throw new Error(`Lookup failed: ${error.message}`);
    }
  },

  lookupWord: async ({ word }) => {
    try {
      const response = await api.get(
        `/platform/words/${word.trim().toLowerCase()}`,
      );
      return extractResponseData(response);
    } catch (error) {
      console.error("Error in lookup:", error);
      throw new Error(`Lookup failed: ${error.message}`);
    }
  },

  lookupWordsByGlyph: async ({ glyph }) => {
    // The backend no longer exposes a glyph-to-words search endpoint,
    // and the Glyph Lookup tab is commented out in the UI.
    // Return an empty object to prevent downstream errors.
    return {};
  },
};
